import {useTimeUnitTranslation} from '@aboutyou/i18n';
import {
  Countdown,
  CountdownUnitProps,
  FONT_SIZES,
} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';

interface CountryLaunchCountDownProps {
  endDate: Date;
  onCountDownEnd?: () => void;
}
interface ExtraProps {
  className: string;
}

const CountryLaunchCountDown: React.FC<CountryLaunchCountDownProps> = ({
  endDate,
  onCountDownEnd,
}) => {
  return (
    <CountDownContainer>
      <Countdown<ExtraProps>
        className={'country-launch-count-down'}
        unitComponent={UnitComponent}
        endDate={endDate}
        onTimeout={onCountDownEnd}
      />
    </CountDownContainer>
  );
};

function UnitComponent({value, unit}: CountdownUnitProps) {
  const timeFormat = useTimeUnitTranslation('short');

  return (
    <UnitContainer>
      <Value>{value}</Value>
      <Unit>{timeFormat[unit]}</Unit>
    </UnitContainer>
  );
}

const UnitContainer = styled.div`
  width: 25%;
  text-align: center;
  display: flex;
  flex-direction: column;
  text-transform: uppercase;
`;

const Value = styled.span`
  font-size: ${FONT_SIZES.px40};
  text-align: center;
`;
const Unit = styled.span`
  font-size: ${FONT_SIZES.px18};
  margin-top: 5px;
  opacity: 0.5;
`;

const CountDownContainer = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 40px 0px;
  .country-launch-count-down {
    width: 100%;
    border-bottom: 0px;
    padding: 0px;
  }
`;

export {CountryLaunchCountDown};
